import { useQueries } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { dashApi } from "@/lib/dashApi";
import { ErrorState, LoadingState, PageHeader, Panel, SourceBadge } from "@/components/dash/ui";
import { TrendQuad } from "@/components/dash/charts";

const HEADLINE: { kpi: string; source: string }[] = [
  { kpi: "odoo.sales_incl", source: "odoo" },
  { kpi: "prestashop.sales_incl", source: "prestashop" },
  { kpi: "repairs.completed", source: "repairs" },
  { kpi: "chat.conversations_new", source: "chat" },
  { kpi: "payments.revenue", source: "payments" },
  { kpi: "stock.units", source: "odoo_stock" },
];

export default function TrendsPage() {
  const results = useQueries({
    queries: HEADLINE.map((h) => ({ queryKey: ["trend", h.kpi], queryFn: () => dashApi.historyTrends(h.kpi) })),
  });

  return (
    <div className="space-y-6">
      <PageHeader
        title="Trends"
        description="Week-on-week, month-on-month, quarter-on-quarter and year-on-year movement from the historical KPI warehouse. Periods with no stored history show no prior figure."
      />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {HEADLINE.map((h, i) => {
          const q = results[i];
          return (
            <Panel
              key={h.kpi}
              title={
                <Link to={`/history?kpi=${encodeURIComponent(h.kpi)}`} className="hover:text-brand-300">
                  {q.data?.label ?? h.kpi}
                </Link>
              }
              right={<SourceBadge code={h.source} />}
            >
              {q.isLoading ? <LoadingState /> : q.isError ? <ErrorState error={q.error} /> : q.data ? <TrendQuad trends={q.data} /> : null}
            </Panel>
          );
        })}
      </div>
    </div>
  );
}
